import { useState } from 'react'
import InputField from '../../components/InputField'
import Label from '../../components/styled/Label'
import { PAYMENT_METHODS } from '../../constants'
import Tipster, {
    PaymentTypes,
    TipsterPaymentsMethods,
} from '../../models/tipster.model'

type Props = {
    payments: TipsterPaymentsMethods
    onUpdate: (payments: TipsterPaymentsMethods) => void
}

const PaymentsUpdateForm = (props: Props) => {
    const [payments, setPayments] = useState<TipsterPaymentsMethods>(
        props.payments || {
            payPalID: '',
            neteller: { id: '', nome: '', cognome: '' },
            skrill: { id: '', nome: '', cognome: '' },
        },
    )
    const update = (newPayments: TipsterPaymentsMethods) => {
        setPayments(newPayments)
        props.onUpdate(newPayments)
    }
    return (
        <div>
            <InputField
                label="Email"
                placeholder="Email"
                type="text"
                className="my-2 mb-4"
                value={payments.paypal.email}
                onChange={(e) =>
                    update({
                        ...payments,
                        paypal: { ...payments.paypal, email: e.target.value },
                    })
                }
            />
        </div>
    )
}

export default PaymentsUpdateForm
